import styled from 'styled-components';

type ProgressBarProps = {
  color: string;
  progress: number;
  max: number;
};

const ProgressBarContainer = styled.div`
  background-color: #babcc2;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: start;
`;

const ProgressBarFill = styled.div<ProgressBarProps>`
  height: 0.1875rem;
  width: ${props => (props.progress / props.max) * 100}%;
  background-color: ${props => props.color};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProgressBar: React.FC<ProgressBarProps> = ({ color, progress, max }) => (
  <ProgressBarContainer>
    <ProgressBarFill color={color} progress={progress} max={max} />
  </ProgressBarContainer>
);

export default ProgressBar;
